module.exports = __webpack_public_path__ + "static/img/12-1.8633af2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/12-1.png
// module id = ZSgA
// module chunks = 15